import { Link } from 'react-router-dom'
import { Phone, Mail, MapPin } from 'lucide-react'
import { useApp } from '../context/app-context'
import { t } from '../i18n'

export default function Footer() {
  const { lang } = useApp()
  const isAr = lang === 'ar'
  const year = new Date().getFullYear()

  const branches = [
    {
      label: isAr ? 'كفر الشيخ، مصر' : 'Kafr El-Sheikh, Egypt',
      href: 'https://maps.google.com/?q=كفر+الشيخ+مصر',
    },
    {
      label: isAr ? 'أكتوبر، الجيزة، مصر' : 'October, Giza, Egypt',
      href: 'https://maps.google.com/?q=السادس+من+أكتوبر+الجيزة+مصر',
    },
    {
      label: isAr ? 'أركان التميز، السعودية' : 'Arkan Al-Tamayoz, Saudi Arabia',
      href: 'https://maps.google.com/?q=أركان+التميز+السعودية',
    },
    {
      label: isAr ? 'توب بيراميدز، البحرين' : 'Top Pyramids, Bahrain',
      href: 'https://maps.google.com/?q=توب+بيراميدز+البحرين',
    },
  ]

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <img src="/logo.png" alt={isAr ? 'شليل للخدمات اللوجستية' : 'Shalil Logistics'} className="footer-logo-img" width={44} height={44} />
            <span>{isAr ? 'شليل للخدمات اللوجستية' : 'Shalil Logistics'}</span>
          </Link>
          <p className="footer-tagline">{t(lang, 'footerTagline')}</p>

        </div>

        <div className="footer-links">
          <h4>{isAr ? 'روابط سريعة' : 'Quick Links'}</h4>
          <ul>
            <li><Link to="/">{t(lang, 'home')}</Link></li>
            <li><Link to="/about">{t(lang, 'about')}</Link></li>
            <li><Link to="/clients">{t(lang, 'clients')}</Link></li>
            <li><Link to="/articles">{t(lang, 'articles')}</Link></li>
            <li><Link to="/contact">{t(lang, 'contact')}</Link></li>
          </ul>
        </div>

        <div className="footer-services">
          <h4>{isAr ? 'خدماتنا' : 'Services'}</h4>
          <ul>
            <li><Link to="/about">{t(lang, 'landFreight')}</Link></li>
            <li><Link to="/about">{t(lang, 'containers')}</Link></li>
          </ul>
        </div>

        <div className="footer-contact">
          <h4>{t(lang, 'contact')}</h4>
          <ul>
            <li>
              <a href="tel:+201028137221" className="footer-contact-item">
                <Phone size={16} />
                <span dir="ltr">+20 102 813 7221</span>
              </a>
            </li>
            <li>
              <a href="tel:+966557466681" className="footer-contact-item">
                <Phone size={16} />
                <span dir="ltr">+966 55 746 6681</span>
              </a>
            </li>
            <li>
              <a href="tel:+966505947475" className="footer-contact-item">
                <Phone size={16} />
                <span dir="ltr">+966 50 594 7475</span>
              </a>
            </li>
            <li>
              <a href="mailto:shelillogistics@gmail.com" className="footer-contact-item">
                <Mail size={16} />
                <span>shelillogistics@gmail.com</span>
              </a>
            </li>
            <li>
              <a href="mailto:info@ercanaltamiz.com" className="footer-contact-item">
                <Mail size={16} />
                <span>info@ercanaltamiz.com</span>
              </a>
            </li>
            {branches.map((branch, i) => (
              <li key={i}>
                <a
                  href={branch.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-contact-item"
                >
                  <MapPin size={16} />
                  <span>{branch.label}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {year} {isAr ? 'شليل للخدمات اللوجستية' : 'Shalil Logistics Services'}. {t(lang, 'allRights')}</p>
        <a
          href="https://maps.google.com/?q=السادس+من+أكتوبر+الجيزة+مصر"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-bottom-map-link"
        >
          <MapPin size={14} aria-hidden="true" />
          <span>{isAr ? 'مدينة السادس من أكتوبر، الجيزة - افتح على الخريطة' : '6th of October City, Giza - View on map'}</span>
        </a>
      </div>
    </footer>
  )
}
